export enum PROGRAMS {
  CKLA = 'ckla',
  CAMINOS = 'caminos',
  ELAR = 'elar',
  ELA = 'ela',
  ELD = 'eld',
  MATH = 'math',
  SCIENCE = 'science',
  BOOST = 'boost',
  VOCAB_APP = 'vocab app',
  MATH_SUPPLEMENTAL = 'math supplemental',
  MCLASS = 'mclass',
}
